module.exports = __webpack_public_path__ + "img/biaoqian_tushuguan.1194b4d1.png";